module.exports = __webpack_public_path__ + "img/4.4ce8d27d.jpg";